<template>
    <Modal v-if="showModal" size="sm" @close="onNo()">
        <div slot="body" class="modal-content">
            <h2 class="heading heading--lg">Insert video</h2>
            <div class="divider divider--10"></div>
            <div class="modal__paragraph">
                <div
                    class="create-asset__input input input--md input--rounded input--grey clearfix"
                >
                    <label
                        for="link"
                        class="create-asset__input-label create-asset__required"
                        >Youtube link</label
                    >

                    <div class="create-asset__input-item">
                        <input
                            id="link"
                            ref="linkfield"
                            v-model="link"
                            name="name"
                            :class="{
                                'is-danger': touched && !isValid && !checking,
                            }"
                            type="text"
                            placeholder="Paste URL here"
                            autocomplete="off"
                            @keyup="onLinkChanged()"
                        />
                    </div>
                    <div class="create-asset__msg">
                        <span
                            v-show="touched && !isValid && !checking"
                            class="create-asset__msg-error is-danger"
                            >Link is not valid</span
                        >
                        <div v-if="previewUrl" class="full-width">
                            <br />
                            <div>Video thumbnail:</div>
                            <div
                                class="video-preview full-width"
                                :style="{
                                    backgroundImage: 'url(' + previewUrl + ')',
                                    backgroundPosition: '50% 50%',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'contain',
                                }"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="divider divider--40"></div>

            <div class="text--center">
                <button
                    class="modal__button-yesno button button--with-icon"
                    @click="onNo"
                >
                    <span>Cancel</span>
                    <i class="icon-no">
                        <NoIcon />
                    </i>
                </button>
                <button
                    class="modal__button-yesno button button--with-icon"
                    :class="{ active: this.isValid }"
                    @click="onYes"
                >
                    <span>Add</span>
                    <i class="icon-finish">
                        <TickIcon />
                    </i>
                </button>
            </div>
        </div>
    </Modal>
</template>
<script>
import UrlParser from 'js-video-url-parser';
import Modal from './Modal.vue';

import NoIcon from 'Svgs/no.svg?inline';
import TickIcon from 'Svgs/tick.svg?inline';

export default {
    components: {
        Modal,
        NoIcon,
        TickIcon,
    },
    data() {
        return {
            showModal: false,
            link: '',
            touched: false,
            checking: false,
            isValid: false,
            previewUrl: null,
        };
    },
    methods: {
        onLinkChanged() {
            this.touched = true;
            this.checking = true;
            this.isValid = true;
            let videoData = UrlParser.parse(this.link);
            if (videoData && videoData.provider === 'youtube') {
                this.isValid = true;
                this.previewUrl =
                    'https://img.youtube.com/vi/' +
                    videoData.id +
                    '/mqdefault.jpg';
                this.checking = false;
                return;
            }
            this.previewUrl = null;
            this.isValid = false;
            this.checking = false
        },
        onYes() {
            if (!this.isValid) {
                return;
            }
            let videoData = UrlParser.parse(this.link);
            let id = videoData.id;

            this.$emit('dialogClose', {
                id: id,
                link:  this.previewUrl,
                // link:
                //     'https:' +
                //     UrlParser.create({
                //         videoInfo: videoData,
                //         format: 'embed',
                //     }),
                params: videoData.params
                    ? { start: videoData.params.start }
                    : null,
            });
        },
        onNo() {
            this.$emit('dialogClose', false);
        },
        init() {
            this.showModal = true;

            setTimeout(() => {
                this.$refs.linkfield.focus();
            }, 300);

            return new Promise(resolve => {
                this.$once('dialogClose', result => {
                    this.showModal = false;
                    this.resetToDefaults();
                    resolve(result);
                });
            });
        },
        resetToDefaults() {
            this.link = '';
            this.touched = false;
            this.checking = false;
            this.isValid = false;
            this.previewUrl = null;
        },
    },
};
</script>
<style scoped>
.full-width {
    width: 100%;
}

.video-preview {
    height: 240px;
}
</style>
